import AdvisorOpportunitiesPage from '@/pages/AdvisorOpportunitiesPage';

function AdvisorLandingPage() {
  return <AdvisorOpportunitiesPage />;
}

export default AdvisorLandingPage;
